import type { SVGProps } from 'react';

const SvgRankingFive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={32}
    viewBox='0 0 32 32'
    width={32}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M24 27.333h-1.333V27c0-1.467-1.2-2.667-2.667-2.667h-3V21.28c-.333.04-.667.053-1 .053s-.667-.013-1-.053v3.053h-3A2.674 2.674 0 0 0 9.333 27v.333H8c-.547 0-1 .454-1 1 0 .547.453 1 1 1h16c.547 0 1-.453 1-1s-.453-1-1-1'
      fill='#5C656A'
    />
    <path
      d='M7.36 15.52c-.88-.333-1.653-.88-2.267-1.493-1.24-1.374-2.053-3.014-2.053-4.934a3.39 3.39 0 0 1 3.427-3.426h.746A5.3 5.3 0 0 0 6.667 8v4c0 1.253.24 2.44.693 3.52M28.96 9.093c0 1.92-.813 3.56-2.053 4.934-.613.613-1.387 1.16-2.267 1.493a9.1 9.1 0 0 0 .694-3.52V8c0-.84-.2-1.627-.547-2.333h.747a3.39 3.39 0 0 1 3.426 3.426'
      fill='#70777D'
    />
    <path
      d='M20 2.667h-8A5.33 5.33 0 0 0 6.667 8v4A9.327 9.327 0 0 0 16 21.333 9.327 9.327 0 0 0 25.334 12V8A5.33 5.33 0 0 0 20 2.667'
      fill='#878E98'
    />
    <g filter='url(#ranking-five)'>
      <path
        d='M15.946 16a3.4 3.4 0 0 1-1.446-.296 2.5 2.5 0 0 1-1.01-.817 2.13 2.13 0 0 1-.383-1.188h1.57q.016.3.189.532.172.231.457.36.284.13.623.13.398 0 .71-.173.316-.177.49-.489a1.44 1.44 0 0 0 .177-.715q0-.408-.178-.726a1.25 1.25 0 0 0-.5-.494 1.46 1.46 0 0 0-.72-.189q-.877.001-1.226.656h-1.463l.42-4.483h4.795V9.43H14.99l-.215 1.968h.065a1.5 1.5 0 0 1 .634-.473 2.3 2.3 0 0 1 .925-.183q.71 0 1.274.328.57.328.892.914.328.58.328 1.317 0 .78-.37 1.393a2.6 2.6 0 0 1-1.044.962q-.666.345-1.532.344'
        fill='#fff'
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
        height={13.226}
        id='ranking-five'
        width={11.118}
        x={10.441}
        y={5.441}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1.333} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.439216 0 0 0 0 0.466667 0 0 0 0 0.490196 0 0 0 1 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_1192_75278' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_1192_75278' result='shape' />
      </filter>
    </defs>
  </svg>
);
export default SvgRankingFive;
